function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

import groupBy from 'lodash/groupBy';
import mapValues from 'lodash/mapValues';
import omit from 'lodash/omit';
import { extractEventingFriendlyFields } from '../../utils/objectUtils';
import { parseTreatmentFields } from '../../utils/treatmentFieldsUtils';
import { EMPTY_ONSITE_MESSAGE_WRAPPER, EVENT_KEY_MAPPING } from './constants';

var mapResponseToNewLaneKeys = function mapResponseToNewLaneKeys(responseObj) {
  var newLaneObj = {};

  if (responseObj) {
    Object.keys(responseObj).forEach(function (key) {
      // Do not send key when value is null
      if (responseObj[key] !== null) {
        if (_typeof(responseObj[key]) === 'object') {
          Object.keys(responseObj[key]).forEach(function (innerKey) {
            if (responseObj[key][innerKey] !== null && EVENT_KEY_MAPPING[key + innerKey]) {
              newLaneObj["" + EVENT_KEY_MAPPING[key + innerKey]] = responseObj[key][innerKey];
            }
          });
        } else if (EVENT_KEY_MAPPING[key]) {
          newLaneObj[EVENT_KEY_MAPPING[key]] = responseObj[key];
        }
      }
    });
  }

  return newLaneObj;
};

export default (function (messageData, placementName, additionalProps, triggerLocation, triggerObject, triggerSource) {
  var _message$selectedTrea, _message$selectedTrea3, _newLaneData$decision, _newLaneData$decision2, _newLaneData$decision3, _newLaneData$decision4, _newLaneData$decision5, _newLaneData$decision6, _newLaneData$decision7, _newLaneData$decision8, _newLaneData$decision9, _newLaneData$decision12, _newLaneData$decision13;

  if (!Array.isArray(messageData === null || messageData === void 0 ? void 0 : messageData.messages)) {
    return null;
  }

  var targetMessages = messageData.messages.find(function (message) {
    return message.placementName === placementName;
  });

  if (!targetMessages) {
    return null;
  }

  var message = targetMessages;
  var componentName = (message === null || message === void 0 ? void 0 : (_message$selectedTrea = message.selectedTreatment) === null || _message$selectedTrea === void 0 ? void 0 : _message$selectedTrea.component) || EMPTY_ONSITE_MESSAGE_WRAPPER; // Create new field so as to not modify incoming prop

  var selectedTreatmentWithFields = {};

  if (message.selectedTreatment) {
    var _message$selectedTrea2;

    var selectedTreatmentName = (_message$selectedTrea2 = message.selectedTreatment) === null || _message$selectedTrea2 === void 0 ? void 0 : _message$selectedTrea2.name;
    selectedTreatmentWithFields = Object.assign(selectedTreatmentWithFields, message === null || message === void 0 ? void 0 : message.selectedTreatment, parseTreatmentFields(selectedTreatmentName));
  }

  var renderingPropsJSONString = message === null || message === void 0 ? void 0 : (_message$selectedTrea3 = message.selectedTreatment) === null || _message$selectedTrea3 === void 0 ? void 0 : _message$selectedTrea3.renderingProps;
  var renderingProps;

  try {
    renderingProps = JSON.parse(renderingPropsJSONString || {});
  } catch (err) {
    renderingProps = {};
  }

  var dspQualifiedTreatments = Object.assign({
    PORTFOLIO: [],
    PORTFOLIO_TEST: [],
    TARGET_SELECTION: [],
    BASELINE_EVALUATION: []
  }, mapValues(groupBy(message.qualifiedTreatments, 'status'), function (clist) {
    return clist.map(function (key) {
      return omit(key, 'status');
    });
  }));
  var qualifiedTreatments = Object.assign({}, mapValues(groupBy(message.qualifiedTreatments, 'status'), function (clist) {
    return clist.map(function (key) {
      return key.name;
    });
  }));
  var newLaneData = Object.assign(Object.assign({}, message), {}, {
    eventId: message === null || message === void 0 ? void 0 : message.eventId,
    decisionContext: (message === null || message === void 0 ? void 0 : message.decisionContext) || {},
    selectedTreatment: omit(selectedTreatmentWithFields, 'component', 'renderingProps'),
    qualifiedTreatments: qualifiedTreatments
  });
  renderingProps = Object.assign(Object.assign({}, renderingProps), {}, {
    eventData: Object.assign(Object.assign({}, message), {}, {
      additionalProps: extractEventingFriendlyFields(additionalProps),
      eventId: message === null || message === void 0 ? void 0 : message.eventId,
      decisionContext: (message === null || message === void 0 ? void 0 : message.decisionContext) || {},
      selectedTreatment: omit(selectedTreatmentWithFields, 'component', 'renderingProps'),
      qualifiedTreatments: dspQualifiedTreatments
    }),
    newLaneEventData: Object.assign(Object.assign({
      triggerLocation: triggerLocation,
      triggerObject: triggerObject,
      triggerSource: triggerSource
    }, mapResponseToNewLaneKeys(newLaneData)), {}, {
      exposureData: {
        exposureAssignments: newLaneData === null || newLaneData === void 0 ? void 0 : (_newLaneData$decision = newLaneData.decisionContext) === null || _newLaneData$decision === void 0 ? void 0 : _newLaneData$decision.exposureAssignments,
        exposureFlags: mapResponseToNewLaneKeys(newLaneData === null || newLaneData === void 0 ? void 0 : (_newLaneData$decision2 = newLaneData.decisionContext) === null || _newLaneData$decision2 === void 0 ? void 0 : _newLaneData$decision2.exposureFlags)
      },
      isNbaProcessed: newLaneData === null || newLaneData === void 0 ? void 0 : (_newLaneData$decision3 = newLaneData.decisionContext) === null || _newLaneData$decision3 === void 0 ? void 0 : (_newLaneData$decision4 = _newLaneData$decision3.nbaContext) === null || _newLaneData$decision4 === void 0 ? void 0 : _newLaneData$decision4.isNbaProcessed,
      position: newLaneData === null || newLaneData === void 0 ? void 0 : (_newLaneData$decision5 = newLaneData.decisionContext) === null || _newLaneData$decision5 === void 0 ? void 0 : (_newLaneData$decision6 = _newLaneData$decision5.nbaContext) === null || _newLaneData$decision6 === void 0 ? void 0 : _newLaneData$decision6.position,
      nbaContext: mapResponseToNewLaneKeys(newLaneData === null || newLaneData === void 0 ? void 0 : (_newLaneData$decision7 = newLaneData.decisionContext) === null || _newLaneData$decision7 === void 0 ? void 0 : _newLaneData$decision7.nbaContext)
    }),
    additionalProps: additionalProps
  });

  if (newLaneData === null || newLaneData === void 0 ? void 0 : (_newLaneData$decision8 = newLaneData.decisionContext) === null || _newLaneData$decision8 === void 0 ? void 0 : (_newLaneData$decision9 = _newLaneData$decision8.nbaContext) === null || _newLaneData$decision9 === void 0 ? void 0 : _newLaneData$decision9.selectedPositionToActionMap) {
    var _newLaneData$decision10, _newLaneData$decision11;

    renderingProps.newLaneEventData.nbaContext = Object.assign(Object.assign({}, renderingProps.newLaneEventData.nbaContext), {}, {
      selected_action_positions: newLaneData === null || newLaneData === void 0 ? void 0 : (_newLaneData$decision10 = newLaneData.decisionContext) === null || _newLaneData$decision10 === void 0 ? void 0 : (_newLaneData$decision11 = _newLaneData$decision10.nbaContext) === null || _newLaneData$decision11 === void 0 ? void 0 : _newLaneData$decision11.selectedPositionToActionMap
    });
  }

  if (newLaneData === null || newLaneData === void 0 ? void 0 : (_newLaneData$decision12 = newLaneData.decisionContext) === null || _newLaneData$decision12 === void 0 ? void 0 : (_newLaneData$decision13 = _newLaneData$decision12.nbaContext) === null || _newLaneData$decision13 === void 0 ? void 0 : _newLaneData$decision13.selectedPositionToFallbackActionMap) {
    var _newLaneData$decision14, _newLaneData$decision15;

    renderingProps.newLaneEventData.nbaContext = Object.assign(Object.assign({}, renderingProps.newLaneEventData.nbaContext), {}, {
      selected_fallback_actions: newLaneData === null || newLaneData === void 0 ? void 0 : (_newLaneData$decision14 = newLaneData.decisionContext) === null || _newLaneData$decision14 === void 0 ? void 0 : (_newLaneData$decision15 = _newLaneData$decision14.nbaContext) === null || _newLaneData$decision15 === void 0 ? void 0 : _newLaneData$decision15.selectedPositionToFallbackActionMap
    });
  }

  return {
    componentName: componentName,
    renderingProps: renderingProps
  };
});